import React from "react";

function CheckBoxWithChildLabel(props){
    return <div className={"pt-4"}>
        <input type={"checkbox"} id={props.fieldName} name={props.fieldName} defaultChecked={props.preChecked} {...props.register(props.fieldName, {required: ('required' in props) ? props.required : true})} />
        <label htmlFor={props.fieldName} className={"text-white ml-2"}>
            {props.children}
        </label>
        {props.errors[props.fieldName]?.type === "required" && <div className={"text-red-500"}>Required</div>}
    </div>
}

export default CheckBoxWithChildLabel
